import React, { useEffect, useState } from "react";
import HandlePromo from "./HandlePromo";
import { authFetch } from "./utils/api";

const HandlePromoWrapper = ({
  tabId,
  quoteId,
  packageData,
  onSavePackage,
  onBaseDataLoaded,
  showLinePrices,
  documentType,
  isOpen,
}) => {
  const isBase = tabId === 1;
  //const [data, setData] = useState(packageData || null);
  //const [data, setData] = useState(() => packageData || null);

  // LOG 1: When component mounts
  console.log('HandlePromoWrapper mounted', { tabId, hasPackageData: !!packageData });

  // LOG 2: When initializing state from props
  const [data, setData] = useState(() => {
    console.log('Initializing data from packageData:', packageData);
    return packageData || null;
  });
  
  const [error, setError] = useState(null);

    // Sync packageData → data when it changes
    useEffect(() => {
        if (packageData && !data) {
        console.log('Syncing packageData to data state:', packageData);
        setData(packageData);
        }
    }, [packageData, data]);
  // 🔹 Load data once for base tab or when quoteId changes
  useEffect(() => {
    let isMounted = true;

    const loadData = async () => {
      if (!isBase) {
        // 🟨 For clone tabs — just use parent data
        if (packageData && isMounted) setData(packageData);
        return;
      }

      try {
        const [quote, itemQuotes] = await Promise.all([
          authFetch(`/quotes/${quoteId}`),
          authFetch(`/itemquotes/byquote/${quoteId}`),
        ]);

        if (!isMounted) return;

        const payload = { quote, itemQuotes };
        setData(payload);

        console.log("✅ Base data loaded");

        // ✅ Only call once (no dependency re-runs)
        if (typeof onBaseDataLoaded === "function") {
          onBaseDataLoaded(quote, itemQuotes);
        }
      } catch (err) {
        console.error("❌ Error loading base quote data:", err);
        if (isMounted)
          setError(err.message || "Failed to load base quote data.");
      }
    };

    loadData();

    return () => {
      isMounted = false;
    };
  }, [isBase, quoteId]); // <-- on purpose, no onBaseDataLoaded or packageData here

  // 🔹 Save handler
  const handleSave = async (updatedData) => {
    if (isBase) {
      try {
        await authFetch(`/quotes/${quoteId}`, {
          method: "PUT",
          body: JSON.stringify(updatedData),
        });
      } catch (err) {
        console.error("Error saving base quote:", err);
      }
    } else {
      // ✅ Local-only update for cloned packages
      onSavePackage(tabId, updatedData);
      setData(updatedData);
    }
  };

  if (error) return <div style={{ color: "red" }}>⚠️ {error}</div>;
  if (!data) return <div>Loading package data...</div>;

  return (
    <HandlePromo
      //key={tabId}  // ← THIS IS THE FIX
      quoteId={quoteId}
      quoteDataWrapper={data.quote}
      itemQuotesWrapper={data.itemQuotes}
      promotionsWrapper={data?.promotions}     // ← NEW
      financingWrapper={data?.financing}       // ← NEW
      crmPromotionsWrapper={data?.crm_promotions}  // ← ADD
      onSaveWrapper={handleSave}
      packageIdWrapper={tabId}
      showLinePrices={showLinePrices}
      documentType={documentType}
      isOpen={isOpen}
    />
  );
};

export default HandlePromoWrapper;
